const React = require('react');
const modulePolycard = require('@polycard/card');
const { Icons, getIcons } = require('@polycard/icons');

const Pagination = require('../Pagination');
const SmartGroupCard = require('@app/components/smartGroupComponent/smartGroup');
const { usePolyCardInteraction } = require('@pages/V2/utils/use-polycard-interaction');

const { Card, PolycardContext } = modulePolycard;

const ItemsList = ({
  polycardContext,
  items,
  paging,
  actualLocation,
  smartGroups,
  appliedFilters = [],
  country,
  smartGroupLinkText,
  userId,
  loginUrl,
}) => {
  const { decimal_separator: decimalSeparator = ',', thousands_separator: thousandsSeparator = '.' } = country;
  const shouldRenderSmartGroups = paging.offset === 0 && Array.isArray(appliedFilters) && appliedFilters.length === 0;
  if (polycardContext && !polycardContext.type) {
    polycardContext.type = 'grid-card';
  }

  const smartGroupMapping = smartGroups?.reduce((map, group) => {
    map[group.position] = group;
    return map;
  }, {});

  const renderItemsWithSmartGroups = () => {
    const combinedItems = [];
    const adsIndices = [];
    const remainingItems = [];

    items.forEach((item, index) => {
      if (item.ads_promotions) {
        adsIndices.push(index);
        combinedItems[index] = item;
      } else {
        remainingItems.push(item);
      }
    });

    let itemCounter = 0;

    remainingItems.forEach((item) => {
      while (combinedItems[itemCounter]) {
        itemCounter++;
      }

      combinedItems[itemCounter] = item;
      itemCounter++;

      if (smartGroups && smartGroupMapping[itemCounter] && shouldRenderSmartGroups) {
        combinedItems[itemCounter] = { isSmartGroup: true, data: smartGroupMapping[itemCounter] };
        itemCounter++;
      }
    });

    return combinedItems.map((item, index) => {
      if (item.isSmartGroup) {
        return (
          <SmartGroupCard
            key={`smartgroup-${index}`}
            smartGroupLinkText={smartGroupLinkText}
            smartGroups={[item.data]}
            offset={0}
            cardsPerRow={1}
          />
        );
      }

      const { itemState, handleBookmark } = usePolyCardInteraction({
        userId,
        item,
        loginUrl,
      });

      if (itemState.ads_promotions) {
        return (
          <React.Fragment key={`ad-${index}`}>
            <Card polycard={itemState} type="grid-card" bookmarkAction={handleBookmark} />
          </React.Fragment>
        );
      }

      return (
        <React.Fragment key={itemState.metadata.id.concat(itemState.pictures.pictures[0].id)}>
          <Card polycard={itemState} type="grid-card" bookmarkAction={handleBookmark} />
        </React.Fragment>
      );
    });
  };

  return (
    <div className="items">
      <div className="items-list">
        <Icons icons={getIcons()} />
        <PolycardContext
          contextValue={polycardContext}
          deviceType="desktop"
          thousandSeparator={thousandsSeparator}
          decimalSeparator={decimalSeparator}
        >
          <div className="items-with-smart-groups">{renderItemsWithSmartGroups()}</div>
        </PolycardContext>
      </div>
      <Pagination paging={paging} actualLocation={actualLocation} className="pagination" />
    </div>
  );
};

module.exports = ItemsList;
